// Need to use the React-specific entry point to import createApi
import type {
  GetDepartmentListRequest,
  GetListResponseOfDepartmentResponse,
  GetListResponseOfSelectOption,
} from 'src/api/ProactApiClient';
import {departmentApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

// Define a service using a base URL and expected endpoints
export const departmentApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getDepartmentSelectOptions: builder.query<
      GetListResponseOfSelectOption,
      GetDepartmentListRequest
    >({
      queryFn: clientQuery(params =>
        departmentApiClient.listSelectOptions(params)
      ),
    }),
    getDepartmentList: builder.query<
      GetListResponseOfDepartmentResponse,
      GetDepartmentListRequest
    >({
      queryFn: clientQuery(params =>
        departmentApiClient.listDepartments(params)
      ),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {useGetDepartmentListQuery, useGetDepartmentSelectOptionsQuery} =
  departmentApi;
